import React, { Component } from "react";
import { connect } from "react-redux";
import {
  Loader,
  Dimmer,
  Segment,
  Header,
  Input,
  Button,
  Message,
  Modal,
  ModalActions,
} from "semantic-ui-react";
import axios from "axios";
import {
  getAllPractitioners,
  getAllEntities,
  selectedPractitioner,
  clearPractitionerInfo,
  deletePractitioner,
  selectedEntity,
  clearEntityInfo,
  deleteEntity,
  getAllPasswordConfigurations
} from "../../actions/auth";
import PractitionersList from "../lists/PractitionersList";
import EntitiesList from "../lists/EntitiesList";
import EditEntityForm from "../forms/EditEntityForm";
import EditPractitionerForm from "../forms/EditPractitionerForm";

import { PasswordConfigurationsTable } from "../tables/PasswordConfigurationsTable";

export class AdminPage extends Component {
  state = {
    practitioners: [],
    entities: [],
    paginatedItems: [],
    filteredPractitioners: [],
    filteredEntities: [],
    allEntities: true,
    allPractitioners: true,
    showAddEntity: false,
    showAddProfile: false,
    saved: false,
    registered: false,
    data: {
      username: "",
      approved: "",
    },
    passwordConfigurations: []
  };
  handleOnClick = () => {
    this.setState({ showAddEntity: !this.state.showAddEntity });
    this.setState({ showAddProfile : !this.state.showAddProfile });
  };

  cancel = () => {
    // console.log("cancel");
    this.setState({
      showAddEntity: false,
      showAddProfile: false
    });
  };

  submit = (data) => {
    axios
      .post("/api/entities/addEntity", {
        data,
      })
      .then((resp) => {
        if (resp.data.created) {
          this.setState({
            saved: true,
            registered: false,
            successMessage:"con exito",
            errorMessage:"",
          });
          setTimeout(() => {
            this.setState({
              saved: false,
              showAddEntity: false,
              showAddProfile : false,
              successMessage:""
            });
          }, 2000);
          this.props.getAllEntities({ role: this.props.role });
        }
        if (resp.data.registered) {
          this.setState({
            saved: false,
            registered: true,
            successMessage:"",
            errorMessage:""
          });
          setTimeout(() => {
            this.setState({
              saved: false,
              registered: false,
              errorMessage:"",
              successMessage:"",
            });
          }, 4000);
        }
      });
  };
  /*Osmar Valencia - api s3*/
  submitPractitioner = (data) => {
    axios
      .post("/api/practitioners/createPractitioner", {
        data,
      })
      .then((resp) => {
        if (resp.data.created) {
          this.setState({
            saved: true,
            registered: false,
            successMessage:"con exito",
            errorMessage:"",
          });
          setTimeout(() => {
            this.setState({
              saved: false,
              showAddEntity: false,
              showAddProfile : false,
              successMessage:""
            });
          }, 2000);
          this.props.getAllPractitioners({ role: this.props.role });
        }
        if (resp.data.registered) {
          this.setState({
            saved: false,
            registered: true,
            successMessage:"",
            errorMessage:'por numero de identificacion, usuario o correo electronico'
          });
          setTimeout(() => {
            this.setState({
              saved: false,
              registered: false,
              errorMessage:""
            });
          }, 4000);
        }
      }).catch((error)=>{
        this.setState({
          errorMessage:"Error al guardar el perfil "+ error.message,
          successMessage:"",
        })
      });
  };
//Fin apiS3
  onInputChange = (e) => {
    const filter = e.target.value;

    if (filter.length > 2) {
      const filteredPractitioners = this.props.practitioners.filter(
        (practitioner) => {
          if (practitioner.fullname.indexOf(filter.toUpperCase()) !== -1) {
            return practitioner;
          }
        }
      );
      this.setState({
        filteredPractitioners,
        allPractitioners: false,
      });
    } else {
      this.setState({
        filteredPractitioners: [],
        allPractitioners: true,
      });
    }
  };

  onInputChangeEntities = (e) => {
    const filter = e.target.value;
    if (filter.length > 2) {
      const filteredEntities = this.props.entities.filter((entity) => {
        if (entity.nombre.indexOf(filter) !== -1) {
          return entity;
        }
      });
      this.setState({
        filteredEntities,
        allEntities: false,
      });
    } else {
      this.setState({
        filteredEntities: [],
        allEntities: true,
      });
    }
  };

  onChangeCheckbox = (e, data) => {
    const practitioners = this.props.practitioners.map((practitioner) => {
      if (practitioner.practitioner_id === data.name) {
        practitioner.approved = data.checked === true ? 1 : 0;
        axios.post("/api/practitioners/approvePractitioner", {
          data: {
            approved: practitioner.approved,
            practitioner_id: practitioner.practitioner_id,
            loggedPractitioner: this.props.loggedPractitioner,
          },
        });
      }
      return practitioner;
    });
    this.setState({
      practitioners: practitioners,
    });
  };

  onChangeEntityCheckbox = (e, data) => {
    const entities = this.props.entities.map((entity) => {
      if (entity.nombre === data.name) {
        entity.activo = data.checked === true ? 1 : 0;
        axios.post("/api/entities/approveEntity", {
          data: {
            approved: entity.activo,
            id: entity.id,
          },
        });
      }
      return entity;
    });
    this.setState({
      entities: entities,
    });
  };

  closeAlert = () => {
    this.setState({
      saved:false,
      registered:false,
      successMessage:"",
      errorMessage:"",
    })
  }

  render() {
    const {
      allPractitioners,
      filteredPractitioners,
      allEntities,
      filteredEntities,
      showAddEntity,
      showAddProfile,
      saved,
      registered,
    } = this.state;
    const {
      isReady,
      isReadyPC,
      entitiesReady,
      practitioners,
      passwordConfigurations,
      entities,
      role,
      loggedPractitioner,
      showPractitionersList,
      showEntitiesList,
      showPasswordConfigurationsList
    } = this.props;
    // console.log(registered);
    return (
      <div>
        {isReady && showPractitionersList ? (
          <Segment>
            <Header as="h1">Lista de perfiles</Header>

            <Input
              fluid
              icon="search"
              size="large"
              placeholder="Búsqueda por nombre"
              onChange={this.onInputChange}
            />
            <div className="addEntityDiv">
              <Button primary onClick={() => this.handleOnClick()}>
                Agregar un perfil profesional
              </Button>
            </div>
            <Modal
              open={saved}
              onClose={this.closeAlert}
              size="small"
              centered            
            >
              <Modal.Header>Operación exitosa</Modal.Header>
              <Modal.Content>
                <Header
                  size="medium"
                  textAlign="center"
                  color="blue"
                >
                  Guardado {this.state.successMessage}
                </Header>
              </Modal.Content>
              <Modal.Actions>
                <Button color="blue" onClick={this.closeAlert}>
                    Aceptar
                </Button>
              </Modal.Actions>
            </Modal>
            <Modal
              open={registered}
              onClose={this.closeAlert}
              size="small"
              centered            
            >
              <Modal.Header>Perfil no creado</Modal.Header>
              <Modal.Content>
                <Header
                  size="medium"
                  textAlign="center"
                  color="red"
                >
                  El perfil ya existe
                </Header>
                <p style={{ textAlign: "center" }}>
                  {this.state.errorMessage}
                </p>
              </Modal.Content>
              <Modal.Actions>
               <Button color="red" onClick={this.closeAlert}>
                    Aceptar
                </Button>
              </Modal.Actions>
            </Modal>
            {showAddProfile ? (
              <Segment>
                <Header size="medium">Agregar perfil</Header>

                <EditPractitionerForm
                  submitPractitioner={this.submitPractitioner}
                  cancel={this.cancel}
                  practitioner_id = ""
                  names = ""
                  lastname1 = ""
                  lastname2 = ""
                  email = ""
                  specialty =""
                  registro = ""
                  gender = ""
                  birthdate = ""
                  phone = ""
                  username = ""
                  password_digest = ""
                  role={role}
                  loggedPractitioner={loggedPractitioner}
                />
              </Segment>
            ) : null}
            <PractitionersList
              showEditForm={this.props.showEditForm}
              selectedPractitioner={this.props.selectedPractitioner}
              clearPractitionerInfo={this.props.clearPractitionerInfo}
              deletePractitioner={this.props.deletePractitioner}
              onChangeCheckbox={this.onChangeCheckbox}
              practitioners={
                allPractitioners ? practitioners : filteredPractitioners
              }
            />
          </Segment>
        ) : entitiesReady && showEntitiesList ? (
          <Segment>
            <Header as="h1">Lista de instituciones</Header>

            <Input
              fluid
              icon="search"
              size="large"
              placeholder="Búsqueda por nombre"
              onChange={this.onInputChangeEntities}
            />
            <div className="addEntityDiv">
              <Button primary onClick={() => this.handleOnClick()}>
                Agregar una institución
              </Button>
            </div>
            <Modal
              open={saved}
              onClose={this.closeAlert}
              size="small"
              centered            
            >
              <Modal.Header>Operación exitosa</Modal.Header>
              <Modal.Content>
                <Header
                  size="medium"
                  textAlign="center"
                  color="blue"
                >
                  Guardado {this.state.successMessage}
                </Header>
              </Modal.Content>
              <Modal.Actions>
                <Button color="blue" onClick={this.closeAlert}>
                    Aceptar
                </Button>
              </Modal.Actions>
            </Modal>
            <Modal
              open={registered}
              onClose={this.closeAlert}
              size="small"
              centered            
            >
              <Modal.Header>Institución no creada</Modal.Header>
              <Modal.Content>
                <Header
                  size="medium"
                  textAlign="center"
                  color="red"
                >
                  La institución ya existe
                </Header>
                <p style={{ textAlign: "center" }}>
                  {this.state.errorMessage}
                </p>
              </Modal.Content>
              <Modal.Actions>
               <Button color="red" onClick={this.closeAlert}>
                    Aceptar
                </Button>
              </Modal.Actions>
            </Modal>
            {showAddEntity ? (
              <Segment>
                <Header size="medium">Agregar institucion</Header>

                <EditEntityForm
                  submit={this.submit}
                  cancel={this.cancel}
                  activo={0}
                  ciudad=""
                  direccion=""
                  email=""
                  id=""
                  nit=""
                  nombre=""
                  telefono=""
                  role={role}
                  loggedPractitioner={loggedPractitioner}
                />
              </Segment>
            ) : null}
            <EntitiesList
              showEditEntityForm={this.props.showEditEntityForm}
              selectedEntity={this.props.selectedEntity}
              clearEntityInfo={this.props.clearEntityInfo}
              deleteEntity={this.props.deleteEntity}
              onChangeEntityCheckbox={this.onChangeEntityCheckbox}
              entities={allEntities ? entities : filteredEntities}
            />
          </Segment>
        ) : isReadyPC && showPasswordConfigurationsList ? (
          <Segment>
            <Header as="h1">Configuración de contraseña</Header>
        
            <PasswordConfigurationsTable
              passwordConfigurations={passwordConfigurations}
            />

          </Segment>
        )
        :(
          <Dimmer active inverted>
            <Loader>Cargando...</Loader>
          </Dimmer>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    practitioners: state.allPractitionersStore,
    entities: state.allEntitiesStore,
    loggedPractitioner: state.practitioner.resp.practitioner_id,
    role: state.practitioner.resp.role,
    isReady: !!state.allPractitionersStore.length,
    entitiesReady: !!state.allEntitiesStore.length,
    passwordConfigurations: state.allPasswordConfigurationsStore,
    isReadyPC: Object.keys(state.allPasswordConfigurationsStore).length > 0
  };
};

export default connect(mapStateToProps, {
  getAllPractitioners,
  getAllEntities,
  selectedPractitioner,
  clearPractitionerInfo,
  deletePractitioner,
  selectedEntity,
  clearEntityInfo,
  deleteEntity,
  getAllPasswordConfigurations
})(AdminPage);
